import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AuthGuard } from './core/guards/auth.guard'

const routes: Routes = [
  // {path: '',redirectTo: '/home',pathMatch: 'full'},

  {
    path: 'login',
    loadChildren: () =>
      import('./modules/login/login.module').then((m) => m.LoginModule)
  },

  {
    path: 'signup',
    loadChildren: () =>
      import('./modules/sign-up/sign-up.module').then((m) => m.SignUpModule)
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules/shell/shell.module').then((m) => m.ShellModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'super-admin',
    loadChildren: () =>
      import('./modules/super-admin//super-admin.module').then(
        (m) => m.SuperAdminModule
      ),
    canActivate: [AuthGuard]
  },
  {
    path: 'acknowledgment',
    loadChildren: () =>
      import('../app/modules/acknowledgment/acknowledgment.module').then(
        (m) => m.AcknowledgmentModule
      )
  },
  { path: '**', redirectTo: '/404' }
]

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
